import Vue from 'vue';
//import 'mdbvue/build/css/mdb.css'; // @note Переопределяет кастомные переменные bootstrap
// import 'mdbvue/src/components/Waves.css';

Vue.component('mdb-container', require('mdbvue/src/components/Container').default);
Vue.component('mdb-btn', require('mdbvue/src/components/Button').default);

Vue.component('mdb-card', require('mdbvue/src/components/Card').default);
Vue.component('mdb-card-header', require('mdbvue/src/components/CardHeader').default);
Vue.component('mdb-card-body', require('mdbvue/src/components/CardBody').default);
//
Vue.component('mdb-card-image', require('mdbvue/src/components/CardImg').default);
Vue.component('mdb-card-title', require('mdbvue/src/components/CardTitle').default);
Vue.component('mdb-card-text', require('mdbvue/src/components/CardText').default);

Vue.component('mdb-tab', require('mdbvue/src/components/Tab').default);
Vue.component('mdb-tab-item', require('mdbvue/src/components/TabItem').default);
Vue.component('mdb-tab-content', require('mdbvue/src/components/TabContent').default);
Vue.component('mdb-tab-pane', require('mdbvue/src/components/TabPane').default);

Vue.component('mdb-modal', require('mdbvue/src/components/Modal').default);
Vue.component('mdb-modal-header', require('mdbvue/src/components/ModalHeader').default);
Vue.component('mdb-modal-title', require('mdbvue/src/components/ModalTitle').default);
Vue.component('mdb-modal-body', require('mdbvue/src/components/ModalBody').default);
Vue.component('mdb-modal-footer', require('mdbvue/src/components/ModalFooter').default);

Vue.component('mdb-icon', require('mdbvue/src/components/Fa').default);
